<script setup>
import {inject, ref} from "vue";

const count2 = ref(0)
const vv= inject('mess')
function incress() {
  count2.value = count2.value + 2
}


</script>

<template>
  <div>
    <RouterLink class="mr-2 border" to="/">Go to Home</RouterLink>
    <RouterLink class="mr-2 border" to="/shop">Shop</RouterLink>
    <RouterLink class="mr-2 border" to="/contact">contact</RouterLink>


    <h1>About vue</h1>
    <p>{{vv}}</p>
    <p> {{ count2 }}</p>


    <br>
    <button class="btn btn-danger" @click="incress">click {{ count2 }}</button>
  </div>
</template>

<style scoped>

</style>